export const openTo = (link) => window.open(link, '_blank');
export const navTo = (el) => el.scrollIntoView({ behavior: 'smooth' });
